import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
	getContractData,
	getContractDataConditionsServiceAcceptedAt,
	getContractDataSectorId,
	getLayoutIsScope,
	getLayoutScopeId,
	getOrganizationById
} from '@spaq/core';
import { getCustomPickupLocations, ServiceInfo } from '@spaq/utils';
import { Service, ServiceBillingType } from '@spaq/utils/service-model';
import { SubscriptionServiceModel } from '@spaq/utils/subscription-model';
import * as moment from 'moment-timezone';

import { firstValueFrom } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { ContractService } from '@shared/store';

@Component({
	selector: 'spaq-service-detail',
	template: `
		<div *ngIf="serviceModel && !serviceModel.isExpired">
			<div class="row">
				<div class="col-md-4" style="font-weight: 500">{{ 'SERVICES.DETAIL.LABEL_DESCRIPTION' | translate }}</div>
				<div class="col-md-8">{{ serviceModel.serviceDescription }}</div>
			</div>
			<span *ngIf="showPriceDetails">
				<div class="row">
					<div class="col-md-4" style="font-weight: 500" *ngIf="!serviceModel.isAtBooking && !serviceModel.isDAS">
						{{ 'SERVICES.DETAIL.LABEL_SERVICE_BILLING_TYPE' | translate }}
					</div>
					<div class="col-md-8" *ngIf="!serviceModel.isAtBooking && !serviceModel.isDAS">
						{{ serviceModel.serviceBillingType }}
					</div>
				</div>

				<div class="row" *ngIf="!serviceModel.isAtBooking">
					<div
						class="col-md-4"
						style="font-weight: 500"
						*ngIf="
							serviceModel.isMonthly &&
							serviceModel.availableServiceId !== 4691 &&
							serviceModel.availableServiceId !== 4780 &&
							serviceModel.availableServiceId !== 9473 &&
							serviceModel.availableServiceId !== 4693 &&
							serviceModel.availableServiceId !== 4723 &&
							serviceModel.availableServiceId !== 9954 &&
							serviceModel.availableServiceId !== 5247 &&
							serviceModel.availableServiceId !== 9952 &&
							serviceModel.availableServiceId !== 5257
						"
					>
						{{ 'SERVICES.DETAIL.LABEL_IS_MONTHLY' | translate }}
					</div>
					<div class="col-md-4" style="font-weight: 500" *ngIf="serviceModel.havePartialAmmount && !serviceModel.isMonthly">
						Prix de l'abonnement (TTC)
					</div>
					<div
						class="col-md-4"
						style="font-weight: 500"
						*ngIf="!serviceModel.isDAS && !serviceModel.havePartialAmmount && !serviceModel.isMonthly"
					>
						{{ 'SERVICES.DETAIL.LABEL_SERVICE_PRICE' | translate }}
					</div>
					<div
						class="col-md-8"
						*ngIf="
							serviceModel.price !== 0 &&
							serviceModel.availableServiceId !== 4691 &&
							serviceModel.availableServiceId !== 4780 &&
							serviceModel.availableServiceId !== 4693 &&
							serviceModel.availableServiceId !== 4723 &&
							serviceModel.availableServiceId !== 9954 &&
							serviceModel.availableServiceId !== 5247 &&
							serviceModel.availableServiceId !== 9952 &&
							serviceModel.availableServiceId !== 5257
						"
					>
						<!-- 10402 Ville de québec qui ne veut pas afficher le prix pour Employés municipaux - Permis mensuel -->
						<span *ngIf="serviceModel.availableServiceId === 10402">Tel que prévu par les conventions collectives</span>
						<div *ngIf="serviceModel.availableServiceId !== 10402">
							<span>{{ serviceModel.price | number : '1.2-2' }} $</span>


							<span *ngIf="serviceModel.isLumpSum && (scopeId$ | async) !== 'CSSC' && !serviceForfaitairePrixFixe.includes(+serviceModel.availableServiceId)"
								>(<strong
									>{{ serviceModel.rawData.duration === 1 ? 'par' : 'pour ' + serviceModel.rawData.duration }}
									{{ serviceModel.formattedDurationTimeUnit }}</strong
								>)</span
							>

							<span *ngIf="serviceForfaitairePrixFixe.includes(+serviceModel.availableServiceId)"
								>(<strong
									>pour la durée sélectionnée</strong
								>)</span
							>

							<span *ngIf="serviceModel.isLumpSum && (scopeId$ | async) === 'CSSC'"
								>(<strong
									>Du
									{{
										moment(serviceModel.serviceStartRule === 'SubscriptionDay' ? moment() : serviceModel.onSaleFrom).format(
											'LL'
										)
									}}
									au
									{{
										moment(serviceModel.serviceStartRule === 'SubscriptionDay' ? moment() : serviceModel.onSaleFrom)
											.add(serviceModel.duration, serviceModel.durationTimeUnitMoment)
											.format('LL')
									}}</strong
								>)</span
							>

							<span
								*ngIf="
									!serviceModel.isMonthly &&
									!serviceModel.isEpisodic &&
									!serviceModel.isLumpSum &&
									!serviceModel.isPerUse &&
									!serviceModel.isDecremental
								"
							>
								(du {{ serviceModel.onSaleFromFormated }} au {{ serviceModel.onSaleUntilFormated }})</span
							>
							<span *ngIf="serviceModel.isMonthly || serviceModel.isEpisodic">
								<span *ngIf="serviceModel.isEpisodic && serviceModel.rawData.duration > 0">
									<span *ngIf="serviceModel.rawData.duration === 1 && serviceModel.rawData.durationTimeUnit === 'Month'"
										>(par mois)</span
									>
									<span *ngIf="serviceModel.rawData.duration > 1 && serviceModel.rawData.durationTimeUnit === 'Month'"
										>(aux {{ serviceModel.rawData.duration }} mois)</span
									>
									<span *ngIf="serviceModel.rawData.durationTimeUnit === 'Week'"
										>(aux {{ serviceModel.rawData.duration }} semaines)</span
									>
								</span>
								<span *ngIf="!(serviceModel.isEpisodic && serviceModel.rawData.duration > 0)"
									><b>{{ 'SERVICES.DETAIL.PER_MONTH' | translate }}</b></span
								>
							</span>
						</div>
					</div>
					<div class="col-md-8" *ngIf="!serviceModel.isDAS && serviceModel.price === 0">
						{{ serviceModel.havePartialAmmount || serviceModel.isMonthly ? 'Gratuite' : 'Gratuit' }}
					</div>
				</div>
				<div class="row" *ngIf="serviceModel.havePartialAmmount">
					<div class="col-md-4" style="font-weight: 500" *ngIf="serviceModel.partialPrice !== '0.00' && partialPrice">
						{{ 'SERVICES.DETAIL.LABEL_PRICE_CURRENT_PERIOD' | translate }}
					</div>
					<div class="col-md-8" *ngIf="serviceModel.partialPrice !== '0.00' && partialPrice">
						{{ serviceModel.partialPrice }} $ (du {{ serviceModel.startDateFormatted }} au
						{{ serviceModel.partialInvoiceToDateFormatter }})
					</div>
				</div>
				<div class="row" *ngFor="let servicePrice of serviceModel.getPricingPeriods()">
					<div
						*ngIf="
							serviceModel.availableServiceId !== 4691 &&
							serviceModel.availableServiceId !== 4780 &&
							serviceModel.availableServiceId !== 9473 &&
							serviceModel.availableServiceId !== 4693 &&
							serviceModel.availableServiceId !== 4723 &&
							serviceModel.availableServiceId !== 9954 &&
							serviceModel.availableServiceId !== 5247 &&
							serviceModel.availableServiceId !== 9952 &&
							serviceModel.availableServiceId !== 5257
						"
						class="col-md-4"
						style="font-weight: 500"
					></div>
					<div
						*ngIf="
							serviceModel.availableServiceId !== 4691 &&
							serviceModel.availableServiceId !== 4780 &&
							serviceModel.availableServiceId !== 9473 &&
							serviceModel.availableServiceId !== 4693 &&
							serviceModel.availableServiceId !== 4723 &&
							serviceModel.availableServiceId !== 9954 &&
							serviceModel.availableServiceId !== 5247 &&
							serviceModel.availableServiceId !== 9952 &&
							serviceModel.availableServiceId !== 5257
						"
						class="col-md-8"
						style=""
					>
						<strong *ngIf="!serviceForfaitaire7jours.includes(+serviceModel.availableServiceId)">{{ servicePrice.price | number : '1.2-2' }} $ (par mois - {{ servicePrice.effectiveDateFormated }})</strong>
						<strong *ngIf="serviceForfaitaire7jours.includes(+serviceModel.availableServiceId)">{{ servicePrice.price | number : '1.2-2' }} $ ({{ servicePrice.effectiveDateFormated }})</strong>
					</div>
				</div>

				<div class="row" *ngIf="showStartAt || serviceModel.serviceStartRule === 'FirstDayOfFlatRateDuration'">
					<div class="col-md-4" style="font-weight: 500">{{ 'SERVICES.DETAIL.LABEL_STARTAT' | translate }}</div>

					<div
						class="col-md-8"
						*ngIf="serviceModel.serviceType !== 'Private' && serviceModel.serviceType !== 'Public'; else startat"
					>
						{{ _startAt }}
					</div>
					<ng-template #startat>
						<div class="col-md-8">{{ _startAt }}</div>
					</ng-template>
				</div>
				<div class="row" *ngIf="showStartAt || serviceModel.serviceStartRule === 'FirstDayOfFlatRateDuration'">
					<div class="col-md-4" style="font-weight: 500">{{ 'SERVICES.DETAIL.LABEL_ENDAT' | translate }}</div>
					<div class="col-md-8">{{ _endAt }}</div>
				</div>
			</span>
			<div class="row">
				<div class="col-md-12" *ngIf="showNote && serviceModel.meta && serviceModel.meta.note">
					<p class="alert alert-warning mt-3" [innerHTML]="serviceModel.meta.note"></p>
				</div>
			</div>
			<div class="row" *ngIf="debug">
				<div class="col-md-4" style="font-weight: 500"></div>
				<div class="col-md-8"><a href="javascript://" (click)="showDebug = true">Voir plus</a></div>
			</div>
			<div class="row">
				<spaq-service-detail-debug [service]="serviceModel" *ngIf="debug && showDebug"></spaq-service-detail-debug>
				<div class="col-md-12" *ngIf="selectable">
					<div
						*ngIf="
							serviceModel.isSubscriptionDay() ||
							serviceModel.isEpisodic ||
							forcePeriodique ||
							serviceModel.isMonthly ||
							serviceModel.isLumpSum ||
							(serviceModel.isDAS && showButton) ||
							serviceModel.isPerUse ||
							serviceModel.isAtBooking ||
							serviceModel.isDecremental
						"
					>
						<div *ngIf="(scopeId$ | async) !== 'CSSC'">
							<div class="mt-4">
								<p style="font-weight: 500;" [hidden]="serviceModel.isAtBooking">
									{{ 'SERVICES.DETAIL.LABEL_CHOOSE_START_DATE' | translate }}
								</p>
								<div *ngIf="(serviceModel.isPerUse || serviceModel.isAtBooking) && !forcePeriodique">
									<kendo-datepicker
										[style.width.px]="360"
										[hidden]="serviceModel.isAtBooking"
										style="max-width: 18.4em"
										id="select-startat"
										data-testid="service-start-date"
										name="startDate"
										[min]="minDate"
										[max]="getEndDate(serviceModel.getAvailablePeriods()[0].startDateRaw)"
										[(ngModel)]="calendarDate"
										(valueChange)="onSelectCalendarDate($event)"
										class="w-100"
									></kendo-datepicker>
								</div>
								<div
									*ngIf="(serviceModel.isMonthly || serviceModel.isDAS || serviceModel.isDecremental) && !forcePeriodique"
								>
									<kendo-datepicker
										[style.width.px]="360"
										*ngIf="serviceModel.serviceStartRule === 'SubscriptionDay' && (isPublic$ | async)"
										style="max-width: 18.4em"
										id="select-startat"
										data-testid="service-start-date"
										name="startDate"
										[min]="minDate"
										[max]="getEndDate(serviceModel.getAvailablePeriods()[0].startDateRaw)"
										[(ngModel)]="calendarDate"
										(valueChange)="onSelectCalendarDate($event)"
										class="w-100"
									></kendo-datepicker>
									<kendo-combobox
										[style.width.px]="360"
										*ngIf="serviceModel.serviceStartRule !== 'SubscriptionDay' || (isPublic$ | async) === false"
										id="select-startat"
										data-testid="service-start-date"
										[(ngModel)]="startDate"
										[data]="serviceModel.getAvailablePeriods(null, (isPublic$ | async) === false || (isCissslan$ | async) === true)"
										[textField]="'start'"
										[valueField]="'value'"
										[placeholder]="'SERVICES.DETAIL.PLACEHOLDER_START_DATE' | translate"
										(ngModelChange)="onSelectEndDate()"
									></kendo-combobox>
								</div>
								<div *ngIf="serviceModel.isLumpSum && serviceModel.parkIdentificationNo === 1813">
									<kendo-datepicker
										[style.width.px]="360"
										style="max-width: 18.4em"
										id="select-startat"
										data-testid="service-start-date"
										name="startDate"
										[min]="minDate"
										[max]="maxDate"
										[(ngModel)]="calendarDate"
										(valueChange)="onSelectCalendarDate($event)"
										class="w-100"
									></kendo-datepicker>
								</div>
								<div
									*ngIf="
										serviceModel.isEpisodic ||
										(serviceModel.isLumpSum && serviceModel.parkIdentificationNo !== 1813) ||
										forcePeriodique
									"
								>
									<kendo-datepicker
										[style.width.px]="360"
										*ngIf="(isPublic$ | async) || forcePeriodique"
										style="max-width: 18.4em"
										id="select-startat"
										data-testid="service-start-date"
										name="startDate"
										[min]="minDate"
										[max]="getEndDate(serviceModel.getAvailablePeriods()[0].startDateRaw)"
										[(ngModel)]="calendarDate"
										(valueChange)="onSelectCalendarDate($event)"
										class="w-100"
									></kendo-datepicker>
									<kendo-datepicker
										[style.width.px]="360"
										*ngIf="
											serviceModel.isSubscriptionDay() &&
											!serviceModel.isEpisodic &&
											(isPublic$ | async) === false &&
											!forcePeriodique
										"
										style="max-width: 18.4em"
										id="select-startat"
										data-testid="service-start-date"
										name="startDate"
										[min]="getDate(serviceModel.getAvailablePeriods()[0].startDateRaw)"
										[max]="getEndDate(serviceModel.getAvailablePeriods()[0].startDateRaw)"
										[(ngModel)]="calendarDate"
										(valueChange)="onSelectCalendarDate($event)"
										class="w-100"
									></kendo-datepicker>
									<kendo-combobox
										[style.width.px]="360"
										*ngIf="
											(!serviceModel.isSubscriptionDay() || serviceModel.isEpisodic) &&
											(isPublic$ | async) === false &&
											!forcePeriodique
										"
										id="select-startat"
										data-testid="service-start-date"
										[(ngModel)]="startDate"
										[data]="serviceModel.getAvailablePeriods(undefined, (isPublic$ | async) === false)"
										[textField]="'start'"
										[valueField]="'value'"
										(ngModelChange)="onSelectEndDate()"
										[placeholder]="'SERVICES.DETAIL.PLACEHOLDER_START_DATE' | translate"
									></kendo-combobox>
								</div>
								<div *ngIf="startDate && (serviceModel.isEpisodic || serviceModel.isLumpSum || forcePeriodique)">
									<p style="font-weight: 500;" class="mt-3">{{ 'SERVICES.DETAIL.LABEL_CHOOSE_END_DATE' | translate }}</p>
									<kendo-combobox
										[style.width.px]="360"
										id="select-endat"
										data-testid="service-end-date"
										[(ngModel)]="endDate"
										[data]="serviceModel.getAvailablePeriods(startDate, (isPublic$ | async) === false)"
										[textField]="'end'"
										[valueField]="'value'"
										(ngModelChange)="onSelectEndDate()"
										[placeholder]="'SERVICES.DETAIL.PLACEHOLDER_END_DATE' | translate"
									></kendo-combobox>
								</div>
							</div>
						</div>
					</div>
					<spaq-service-accept-conditions [service]="_service" [test]="startDate"></spaq-service-accept-conditions>
					<div
						*ngIf="
							((serviceModel.isEpisodic || serviceModel.isLumpSum || forcePeriodique) && startDate && (endDate)) ||
							(startDate && !forcePeriodique && !(serviceModel.isEpisodic || serviceModel.isLumpSum))
						"
					>
						<div
							class="mt-3"
							*ngIf="_service.isApprovable && (startDate || serviceModel.isPerUse || serviceModel.isDecremental)"
						>
							<input
								[(ngModel)]="isChecked"
								[checked]="paymentApprobationAcceptedAt$ | async"
								type="checkbox"
								(change)="onAccept(isChecked)"
								id="check_approval"
								data-testid="service-approval"
								kendoCheckBox
							/>
							<label class="k-checkbox-label" for="check_approval"
								>Je comprends que l'accès au stationnement nécessite l'approbation de la SPAQ.</label
							>
						</div>
						<div
							class="mt-3"
							*ngIf="
								!serviceModel.isSubscriptionAvailable &&
								_service.isApprovable &&
								(enableWaitingList$ | async)
							"
						>
							<input
								[(ngModel)]="isCheckedWaitList"
								[checked]="waitList$ | async"
								type="checkbox"
								(change)="onAcceptWaitList(isCheckedWaitList)"
								id="check_waitlist"
								data-testid="service-waitlist"
								kendoCheckBox
							/>
							<label class="k-checkbox-label" for="ch4"
								>Je souhaite m'inscrire sur la liste d'attente si le stationnement est complet</label
							>
						</div>
					</div>
					<div>
						<spaq-button
							[disabled]="
								(acceptedAt$ | async | isNullOrEmpty) ||
								((paymentApprobationAcceptedAt$ | async) === false && _service.isApprovable) ||
								!(serviceModel.isSubscriptionAvailable || (waitList$ | async)) ||
								(serviceModel.isEpisodic && (!startDate || !endDate)) ||
								(serviceModel.isLumpSum && (!startDate || !endDate)) ||
								(serviceModel.isMonthly && !startDate)
							"
							(buttonClick)="clickSelectService()"
							testId="select-service"
							[primary]="true"
							class="d-inline-block"
						>
							{{
								(serviceModel.isSubscriptionAvailable || isAdmin
									? 'SERVICES.DETAIL.BUTTON_SELECT_SERVICE'
									: !(
											((enableWaitingList$ | async) || (isPublic$ | async)) &&
											!(
												serviceModel.rawData.serviceBillingType === 'PerUse' ||
												serviceModel.rawData.serviceBillingType === 'Decremental'
											)
									  )
									? 'Cet abonnement est indisponible'
									: (enableWaitingList$ | async)
									? "S'inscrire à la liste d'attente"
									: 'Cet abonnement est indisponible'
								) | translate
							}}
						</spaq-button>
						<p
							class="mt-2"
							*ngIf="
								!serviceModel.isSubscriptionAvailable &&
								!(
									((enableWaitingList$ | async) || (isPublic$ | async)) &&
									!(
										serviceModel.rawData.serviceBillingType === 'PerUse' ||
										serviceModel.rawData.serviceBillingType === 'Decremental'
									)
								)
							"
							style="color: red"
						>
							* Non disponible, toutes les places sont occupées.
						</p>
					</div>
				</div>
			</div>
		</div>
	`,
	styles: [
		`
			::ng-deep .k-checkbox {
				border-color: #6f6f6f !important;
			}

			kendo-combobox {
				width: 300px;
			}

			.col-md-4 {
				font-weight: 400;
			}
		`
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceDetailComponent implements OnInit {
	serviceForfaitaire7jours = [9911, 9912, 9913]; // on affiche pas -> $ (par mois - {{ servicePrice.effectiveDateFormated }})
	serviceForfaitairePrixFixe = [9407, 10304]; //  on affiche pas le par ou pour puisque c'est un prix fixe

	showDebug = false;
	isChecked = false;
	@Input() isAdmin = false;
	@Input()
	showStartAt = true;
	@Input()
	forcePeriodique = false;
	isCheckedWaitList = false;
	calendarDate = null;
	calendarEndDate = null;
	sectorId$ = this.store.pipe(select(getCustomPickupLocations));
	selectedGroupId$ = this.store.pipe(
		select(getContractDataSectorId),
		filter((x: any) => (x && x.id) || false),
		map(x => x.id),
		switchMap(gid =>
			this.store.pipe(
				select(getCustomPickupLocations),
				map((x: any) => (x && x[gid]) || null)
			)
		)
	);

	acceptedAt$ = this.store.pipe(select(getContractDataConditionsServiceAcceptedAt));
	paymentApprobationAcceptedAt$ = this.store.pipe(
		select(getContractData),
		map((c: any) => !!(c || {}).paymentApprobationAcceptedAt),
		tap((isChecked: boolean) => {
			this.isChecked = !!isChecked;
		})
	);
	scopeId$ = this.store.pipe(select(getLayoutScopeId));
	isScope$ = this.store.pipe(select(getLayoutIsScope));
	isPublic$ = this.store.pipe(
		select(getLayoutScopeId),
		map(x => x === 'PUBLIC' || x === 'ULAVAL' || x === 'CISSSLAN' || x === 'CISSSLAU')
	);
	isCissslan$ = this.scopeId$.pipe(map(x => x === 'CISSSLAN'));
	enableWaitingList$ = this.scopeId$.pipe(
		switchMap(id =>
			this.store.pipe(select(getOrganizationById, id)).pipe(map((x: any) => Boolean(x && x.config && x.config.enableWaitingList)))
		)
	);

	waitList$ = this.store.pipe(
		select(getContractData),
		map((c: any) => !!(c || {}).enableWaitingList),
		tap((isChecked: boolean) => {
			this.isCheckedWaitList = !!isChecked;
		})
	);

	get toDay() {
		return moment(new Date()).startOf('day').toDate();
	}
	get minDate(): Date {
		const today = moment().startOf('day');
		const onSaleFrom = moment(this.serviceModel.onSaleFrom).startOf('day');

		return onSaleFrom.isAfter(today) ? onSaleFrom.toDate() : today.toDate();
	}

	get maxDate(): Date {
		const onSaleUntil = moment(this.serviceModel.onSaleUntil).startOf('day');

		return onSaleUntil.toDate();
	}
	get _endAt() {
		if (this.serviceModel.serviceStartRule === 'FirstDayOfFlatRateDuration') {
			return moment(this.serviceModel.onSaleFrom || null)
				.add(this.serviceModel.duration, this.serviceModel.durationTimeUnitMoment)
				.format('LL');
		}
		if (this.endAt) {
			return this.endAt;
		}
		if (this.subscriptionService && !this.serviceModel.period) {
			if (moment(this.subscriptionService.rawData.endDate).get('year') === 9999) {
				return 'Indéterminée';
			}
			return moment(this.subscriptionService.rawData.endDate).tz('America/Montreal').format('LL');
		}
		return this.serviceModel.endDateFormatted;
	}

	_service: Service;

	@Input()
	set service(s: ServiceInfo) {
		this._service = new Service(s);
	}

	get _startAt() {
		if (this.subscriptionService?._data.isApproved === false) {
			if (this.subscriptionService?._data.effectiveDate) {
				if (moment().diff(moment(this.subscriptionService?._data.effectiveDate || null), 'days') >= 0) {
					return (
						moment(this.subscriptionService?.effectiveDate || this.serviceModel.onSaleFrom || null).format('LL') +
						" ou jour de l'approbation"
					);
				}
			}
		}

		if (this.subscriptionService?.effectiveDate) {
			return moment(this.subscriptionService?.effectiveDate || null).format('LL');
		}

		if (this.serviceModel.serviceStartRule === 'FirstDayOfFlatRateDuration') {
			return moment(this.serviceModel.onSaleFrom || null).format('LL');
		}

		if (this.startAt) {
			return this.startAt;
		}
		return this.serviceModel.startDateFormatted;
	}

	_subscriptionService;

	get subscriptionService() {
		return this._subscriptionService;
	}

	@Input()
	set subscriptionService(s) {
		this._subscriptionService = new SubscriptionServiceModel(s);
	}

	getDate(date) {
		return moment(date).toDate();
	}

	getEndDate(_date) {
		return moment().add(3, 'month').toDate();
	}

	onSelectCalendarDate(_$event) {
		this.startDate = null;
		this.startDate = { force: !!this.forcePeriodique, startDateRaw: moment(this.calendarDate).toISOString() };
		this.endDate = { force: !!this.forcePeriodique, startDateRaw: moment(this.calendarDate).toISOString() };
		this.onSelectEndDate(true);
	}

	onSelectCalendarEndDate(_$event) {
		this.endDate = null;
		this.endDate = {
			force: true,
			endDateRaw: moment(this.calendarEndDate).toISOString(),
			startDateRaw: moment(this.calendarDate).toISOString()
		};

		this.onSelectEndDate(false);
	}

	onSelectEndDate(resetEndDate = false) {
		if (resetEndDate) {
			this.endDate = null;
		}
		if (this.forcePeriodique) {
			if (!this.endDate) {
				this.endDate = {};
			}
			this.endDate.force = true;
		}
		this.contractService.acceptConditionsServiceApprobationPayment(false).pipe(take(1)).subscribe();
	}

	get data() {
		const data = [];
		const startAt = moment(this.endDate).startOf('month').subtract(1, 'day');
		const totalMonth = Math.ceil(
			moment(this.serviceModel.endDate).startOf('month').diff(moment(startAt).endOf('month'), 'months', true)
		);

		for (let _i = 1; _i <= totalMonth; _i++) {
			const endDate = moment(startAt).add(_i, 'month').startOf('month').subtract(1, 'day').format('LL');
			data.push({ text: _i, value: `${_i} mois (jusqu'au ${endDate})` });
		}

		return data;
	}

	get sDate() {
		return this.serviceModel.startDateFormatted;
	}

	get serviceBillingType() {
		if (!this.service) {
			return null;
		}
		return ServiceBillingType[this.serviceModel.serviceBillingType];
	}

	get serviceModel(): Service {
		return this._service;
	}

	get test() {
		if (this.endDate) {
			return;
		}
		return null;
	}

	@Input() debug = false;
	@Input() endAt;
	public endDate;
	public max: Date = new Date(2002, 2, 10);
	public min: Date = new Date(2000, 2, 10);
	@Input() partialPrice = false;
	@Output() selectService = new EventEmitter();
	@Input() selectable = true;
	@Input() showButton = true;
	@Input() showNote = true;
	@Input() showPriceDetails = true;
	@Input() startAt;
	public startDate: unknown = null;

	constructor(
		private store: Store,
		public contractService: ContractService
	) {}

	onAccept(value) {
		return this.contractService.acceptConditionsServiceApprobationPayment(value).pipe(take(1)).subscribe();
	}

	onAcceptWaitList(value) {
		return this.contractService.acceptWaitList(value).pipe(take(1)).subscribe();
	}

	async ngOnInit() {
		const scope = await firstValueFrom(this.scopeId$.pipe(take(1)));

		if (scope === 'ULAVAL') {
			this.calendarDate = moment(this.minDate).toDate();
			this.onSelectCalendarDate(null);

			this.calendarEndDate = moment(this.calendarDate)
				.clone()
				.add(this.serviceModel.duration, this.serviceModel.durationTimeUnitMoment)
				.toDate();

			this.endDate = {
				force: true,
				endDateRaw: moment(this.calendarEndDate).toISOString(),
				end: moment(this.calendarEndDate).format('LL'),
				startDateRaw: moment(this.calendarDate).toISOString(),
				start: moment(this.calendarDate).format('LL')
			};

			this.onSelectEndDate(false);
		}

		if (scope === 'CSSC') {
			this.calendarDate = moment(
				this.serviceModel.serviceStartRule === 'SubscriptionDay' ? new Date() : this.serviceModel.onSaleFrom
			).toDate();
			this.onSelectCalendarDate(null);

			this.calendarEndDate = moment(this.calendarDate)
				.clone()
				.add(this.serviceModel.duration, this.serviceModel.durationTimeUnitMoment)
				.toDate();

			this.endDate = {
				force: true,
				endDateRaw: moment(this.calendarEndDate).toISOString(),
				end: moment(this.calendarEndDate).format('LL'),
				startDateRaw: moment(this.calendarDate).toISOString(),
				start: moment(this.calendarDate).format('LL')
			};

			this.onSelectEndDate(false);
		} else if (this.serviceModel.isAtBooking && !this.showStartAt && !this.calendarDate) {
			this.calendarDate = new Date();
			this.onSelectCalendarDate(null);
		}
	}

	clickSelectService() {
		let selectedService = this.serviceModel.rawData;
		if (this.forcePeriodique && this.startDate && this.endDate) {
			selectedService = { ...selectedService, period: this.endDate };
		} else {
			if (this.serviceModel.isEpisodic && this.startDate && this.endDate) {
				selectedService = { ...selectedService, period: this.endDate };
			}
			if (this.serviceModel.isLumpSum && this.startDate && this.endDate) {
				selectedService = { ...selectedService, period: this.endDate };
			}
			if (this.serviceModel.isMonthly || (this.serviceModel.rawData.serviceBillingType === 'DAS' && this.startDate)) {
				selectedService = { ...selectedService, period: this.startDate };
			}
		}

		this.selectService.emit(selectedService);
	}

	protected readonly moment = moment;
}
